import { gsap } from 'gsap';
import ControllerBringSymbolsToFront from './ControllerBringSymbolsToFront';

export default class ControllerWinCombination {
  constructor({ reelsContainer, controllerReels, topContainer }) {
    this.ControllerReels = controllerReels;
    this.containerReels = reelsContainer;
    this.ControllerBringToFrontSymbols = new ControllerBringSymbolsToFront(topContainer);
    this._initOverlay();
  }

  showCombination(data) {
    this._setAllSymbolsActive(false);
    this.overlay.visible = true;
    gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    data.params.path.forEach((pathData, index) => {
      if (pathData >= 0) {
        const symbol = this.ControllerReels.reels[index].symbols[pathData];
        this.ControllerBringToFrontSymbols.bringToFront(symbol);
        symbol.setActive(true);
        symbol.startAnimation();
      }
    });
  }

  showBonusGameStart(symbols) {
    this._setAllSymbolsActive(false);
    this.overlay.visible = true;
    gsap.to(this.overlay, { alpha: 1, duration: 0.2 });
    symbols.forEach(symbol => {
        this.ControllerBringToFrontSymbols.bringToFront(symbol);
        symbol.setActive(true);
        symbol.startStopAnimation();
    });
  }

  end() {
    this._setAllSymbolsActive(true);
    this.ControllerBringToFrontSymbols.bringAllBack();
    gsap.to(this.overlay, {
      alpha: 0, duration: 0.2, onComplete: () => {
        this.overlay.visible = false;
      }
    });
  }

  _setAllSymbolsActive(value) {
    this.ControllerReels.reels.forEach(reel => reel.symbols.forEach(symbol => {
      symbol.stopAnimation();
      symbol.setActive(value);
    }));
  }

  _initOverlay() {
    this.overlay = new PIXI.Graphics();
    this.containerReels.addChildAt(this.overlay, 0);

    this.overlay.beginFill(0x080342, 0.75);
    this.overlay.drawRoundedRect(0, 278, 1280, 852, 40);
    this.overlay.endFill();
    this.overlay.visible = false;
  }
}
